import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Outlook = function Outlook(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    // The path data below is authored on a much larger canvas (up to
    // x≈1831, y≈1705 — matches the gradient's vertical-flip translate
    // of 1705.3334) than a plain 0 0 48 48 viewBox would show; that
    // mismatch clipped almost the entire icon outside the visible area.
    viewBox: "0 0 1831.083 1705.333",
    width: "48px",
    height: "48px",
    fill: "none",
    children: [/*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "outlook-a",
        gradientTransform: "matrix(1 0 0 -1 0 1705.3334)",
        gradientUnits: "userSpaceOnUse",
        x1: "1128.4584",
        x2: "1128.4584",
        y1: "811.0833",
        y2: "1.9982",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#35b8f1"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#28a8ea"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "outlook-b",
        gradientTransform: "matrix(1 0 0 -1 0 1705.3334)",
        gradientUnits: "userSpaceOnUse",
        x1: "162.7469",
        x2: "774.0864",
        y1: "1383.0741",
        y2: "324.2592",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#1784d9"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".5",
          stopColor: "#107ad5"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#0a63c9"
        })]
      })]
    }), /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m1831.083 894.25c.1-14.318-7.298-27.644-19.503-35.131h-.213l-.767-.426-634.492-375.585c-2.74-1.851-5.583-3.543-8.517-5.067-24.498-12.639-53.599-12.639-78.098 0-2.934 1.525-5.777 3.216-8.517 5.067l-634.49 375.585-.766.426c-19.392 12.059-25.337 37.556-13.278 56.948 3.553 5.714 8.447 10.474 14.257 13.868l634.492 375.585c2.749 1.835 5.592 3.527 8.517 5.068 24.498 12.639 53.599 12.639 78.098 0 2.925-1.541 5.767-3.232 8.517-5.068l634.492-375.585c12.675-7.39 20.413-21.012 20.268-35.685z",
        fill: "#0a2767"
      }), /*#__PURE__*/_jsx("path", {
        d: "m520.453 643.477h416.38v381.674h-416.38zm1225.464-387.977v-174.592c1-43.652-33.552-79.862-77.203-80.908h-1080.51c-43.652 1.046-78.204 37.256-77.204 80.908v174.592l638.75 170.333z",
        fill: "#0364b8"
      }), /*#__PURE__*/_jsx("path", {
        d: "m511 255.5h425.833v383.25h-425.833z",
        fill: "#0078d4"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1362.667 255.5h-425.834v383.25l425.834 383.25h383.25v-383.25z",
        fill: "#28a8ea"
      }), /*#__PURE__*/_jsx("path", {
        d: "m936.833 638.75h425.833v383.25h-425.833z",
        fill: "#0078d4"
      }), /*#__PURE__*/_jsx("path", {
        d: "m936.833 1022h425.833v383.25h-425.833z",
        fill: "#0364b8"
      }), /*#__PURE__*/_jsx("path", {
        d: "m520.453 1025.151h416.38v346.969h-416.38z",
        fill: "#14447d"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1362.667 1022h383.25v383.25h-383.25z",
        fill: "#0078d4"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1811.58 927.593-.809.426-634.492 356.848c-2.768 1.703-5.578 3.321-8.517 4.769-10.777 5.132-22.481 8.029-34.407 8.517l-34.663-20.27c-2.929-1.47-5.773-3.105-8.517-4.897l-643.008-366.983h-.298l-21.036-11.753v722.384c.328 48.196 39.653 87.006 87.849 86.7h1230.914c.724 0 1.363-.341 2.129-.341 10.18-.651 20.216-2.745 29.808-6.217 4.145-1.756 8.146-3.835 11.966-6.217 2.853-1.618 7.75-5.152 7.75-5.152 21.814-16.142 34.726-41.635 34.833-68.772v-722.385c-.014 13.817-7.466 26.557-19.502 33.343z",
        fill: "url(#outlook-a)"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1797.017 891.397v44.287l-663.448 456.791-686.87-486.174c0-.235-.191-.426-.426-.426l-63.023-37.899v-31.938l25.976-.426 54.932 31.512 1.277.426 4.684 2.981s645.563 368.346 647.267 369.197l24.698 14.478c2.129-.852 4.258-1.703 6.813-2.555 1.278-.852 640.879-360.681 640.879-360.681z",
        fill: "#0a2767",
        opacity: ".5"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1811.58 927.593-.809.468-634.492 356.848c-2.768 1.703-5.578 3.321-8.517 4.769-24.641 12.038-53.457 12.038-78.098 0-2.918-1.445-5.76-3.037-8.517-4.769l-634.49-356.848-.766-.468c-12.25-6.642-19.93-19.409-20.057-33.343v722.384c.305 48.188 39.616 87.004 87.803 86.7h.004 1229.636c48.188.307 87.5-38.509 87.807-86.696 0-.001 0-.002 0-.004v-722.384c-.016 13.817-7.468 26.557-19.504 33.343z",
        fill: "#1490df"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1185.52 1279.629-9.496 5.323c-2.752 1.752-5.595 3.359-8.517 4.812-10.462 5.135-21.838 8.146-33.47 8.857l241.405 285.479 421.107 101.476c11.539-8.716 20.717-20.178 26.7-33.343z",
        opacity: ".1"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1228.529 1255.442-52.505 29.51c-2.752 1.752-5.595 3.359-8.517 4.812-10.462 5.135-21.838 8.146-33.47 8.857l113.101 311.838 549.538 74.989c21.649-16.254 34.394-41.743 34.407-68.815v-9.326z",
        opacity: ".05"
      }), /*#__PURE__*/_jsx("path", {
        d: "m514.833 1703.333h1228.316c18.901.096 37.335-5.874 52.59-17.033l-697.089-408.331c-2.929-1.47-5.773-3.105-8.517-4.897l-643.008-366.984h-.298l-20.993-11.838v719.914c-.048 49.2 39.798 89.122 88.999 89.169-.001 0-.001 0 0 0z",
        fill: "#28a8ea"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1022 418.722v908.303c-.076 31.846-19.44 60.471-48.971 72.392-9.148 3.931-19 5.96-28.957 5.962h-518.239v-1022.129h85.167v-42.583h433.073c43.019.163 77.834 35.035 77.927 78.055z",
        opacity: ".1"
      }), /*#__PURE__*/_jsx("path", {
        d: "m979.417 461.305v908.302c.107 10.287-2.074 20.469-6.388 29.808-11.826 29.149-40.083 48.273-71.54 48.417h-475.656v-1064.582h475.656c12.356-.124 24.533 2.958 35.344 8.943 26.104 13.151 42.574 39.883 42.584 69.112z",
        opacity: ".2"
      }), /*#__PURE__*/_jsx("path", {
        d: "m979.417 461.305v823.136c-.208 43-34.928 77.853-77.927 78.225h-475.657v-979.416h475.656c12.356-.124 24.533 2.958 35.344 8.943 26.104 13.151 42.574 39.883 42.584 69.112z",
        opacity: ".2"
      }), /*#__PURE__*/_jsx("path", {
        d: "m936.833 461.305v823.136c-.046 43.067-34.861 78.015-77.927 78.225h-433.073v-979.416h433.072c43.062.023 77.951 34.951 77.927 78.013.001.014.001.028.001.042z",
        opacity: ".2"
      }), /*#__PURE__*/_jsx("path", {
        d: "m78.055 383.25h780.723c43.109 0 78.055 34.947 78.055 78.055v780.723c0 43.109-34.946 78.055-78.055 78.055h-780.723c-43.109 0-78.055-34.947-78.055-78.055v-780.723c0-43.108 34.947-78.055 78.055-78.055z",
        fill: "url(#outlook-b)"
      }), /*#__PURE__*/_jsx("path", {
        d: "m243.96 710.631c19.238-40.988 50.29-75.289 89.17-98.495 43.057-24.651 92.081-36.94 141.675-35.515 45.965-.997 91.321 10.655 131.114 33.683 37.414 22.312 67.547 55.004 86.742 94.109 20.904 43.09 31.322 90.512 30.405 138.396 1.013 50.043-9.706 99.628-31.299 144.783-19.652 40.503-50.741 74.36-89.425 97.388-41.327 23.734-88.367 35.692-136.011 34.578-46.947 1.133-93.303-10.651-134.01-34.067-37.738-22.341-68.249-55.07-87.892-94.28-21.028-42.467-31.57-89.355-30.745-136.735-.876-49.617 9.474-98.79 30.276-143.845zm95.046 231.227c10.257 25.912 27.651 48.385 50.163 64.812 22.93 16.026 50.387 24.294 78.353 23.591 29.783 1.178 59.14-7.372 83.634-24.358 22.227-16.375 39.164-38.909 48.715-64.812 10.677-28.928 15.946-59.572 15.543-90.404.33-31.127-4.623-62.084-14.649-91.554-8.855-26.607-25.246-50.069-47.182-67.537-23.88-17.79-53.158-26.813-82.91-25.55-28.572-.74-56.644 7.593-80.184 23.804-22.893 16.496-40.617 39.168-51.1 65.365-23.255 60.049-23.376 126.595-.341 186.728z",
        fill: "#fff"
      }), /*#__PURE__*/_jsx("path", {
        d: "m1362.667 255.5h383.25v383.25h-383.25z",
        fill: "#50d9ff"
      })]
    })]
  }));
};
export default Outlook;